export default __webpack_public_path__ + "add7c9d49b44030e954733abdb77a279.png";